module.exports = __webpack_public_path__ + "static/media/job.9dcf47b0.svg";